import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import '@tn-equis/core/utils';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

var EquisSpinnerSizes;
(function (EquisSpinnerSizes) {
    EquisSpinnerSizes["EXTRA_SMALL"] = "extra-small";
    EquisSpinnerSizes["SMALL"] = "small";
    EquisSpinnerSizes["MEDIUM"] = "medium";
    EquisSpinnerSizes["LARGE"] = "large";
    EquisSpinnerSizes["EXTRA_LARGE"] = "extra-large";
})(EquisSpinnerSizes || (EquisSpinnerSizes = {}));
var EquisSpinnerTypes;
(function (EquisSpinnerTypes) {
    EquisSpinnerTypes["PRIMARY"] = "primary";
    EquisSpinnerTypes["SECONDARY"] = "secondary";
})(EquisSpinnerTypes || (EquisSpinnerTypes = {}));

class EquisSpinnerComponent {
    constructor() {
        this._size = EquisSpinnerSizes.EXTRA_LARGE;
        this._type = EquisSpinnerTypes.PRIMARY;
    }
    set size(size) {
        this._size = Object.values(EquisSpinnerSizes).includes(size)
            ? size
            : EquisSpinnerSizes.EXTRA_LARGE;
    }
    get size() {
        return this._size;
    }
    set type(type) {
        this._type = Object.values(EquisSpinnerTypes).includes(type)
            ? type
            : EquisSpinnerTypes.PRIMARY;
    }
    get type() {
        return this._type;
    }
    get isPrimary() {
        return this._type === EquisSpinnerTypes.PRIMARY;
    }
}
EquisSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisSpinnerComponent, selector: "z-spinner , equis-spinner ", inputs: { size: "size", type: "type" }, ngImport: i0, template: "<div class=\"spinner\" [ngClass]=\"['spinner--' + size, 'spinner--' + type]\">\n  <svg class=\"spinner__paths\" viewBox=\"25 25 50 50\">\n    <circle\n      class=\"spinner__static-path\"\n      cx=\"50\"\n      cy=\"50\"\n      r=\"20\"\n      fill=\"none\"\n      stroke-width=\"4\"\n      stroke-miterlimit=\"10\"\n    />\n    <circle\n      [ngClass]=\"[\n        'spinner__moving-path',\n        isPrimary ? 'spinner-primary-base' : 'stroke-spinner-default'\n      ]\"\n      cx=\"50\"\n      cy=\"50\"\n      r=\"20\"\n      fill=\"none\"\n      stroke-width=\"4\"\n      stroke-miterlimit=\"10\"\n    />\n  </svg>\n</div>\n", styles: [".stroke-spinner-default{stroke:#fff}:host{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.spinner{background-color:transparent;border-radius:50%;height:100%;margin:0 auto;position:relative;--spinner-moving-path-color: #fe5000;height:64px;width:64px}.spinner__paths{animation:rotate 2s linear infinite;height:100%;inset:0;margin:auto;position:absolute;transform-origin:center center;width:100%}.spinner__moving-path{animation:dash 1.1s ease-in-out infinite;stroke-dasharray:1,200;stroke-dashoffset:0;stroke-linecap:square}.spinner--secondary{--spinner-moving-path-color: #ffffff}.spinner--large{height:48px;width:48px}.spinner--medium{height:32px;width:32px}.spinner--small{height:24px;width:24px}.spinner--extra-small{height:16px;width:16px}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:130,200;stroke-dashoffset:-70px}to{stroke-dasharray:130,200;stroke-dashoffset:-175px}}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-spinner , equis-spinner ', template: "<div class=\"spinner\" [ngClass]=\"['spinner--' + size, 'spinner--' + type]\">\n  <svg class=\"spinner__paths\" viewBox=\"25 25 50 50\">\n    <circle\n      class=\"spinner__static-path\"\n      cx=\"50\"\n      cy=\"50\"\n      r=\"20\"\n      fill=\"none\"\n      stroke-width=\"4\"\n      stroke-miterlimit=\"10\"\n    />\n    <circle\n      [ngClass]=\"[\n        'spinner__moving-path',\n        isPrimary ? 'spinner-primary-base' : 'stroke-spinner-default'\n      ]\"\n      cx=\"50\"\n      cy=\"50\"\n      r=\"20\"\n      fill=\"none\"\n      stroke-width=\"4\"\n      stroke-miterlimit=\"10\"\n    />\n  </svg>\n</div>\n", styles: [".stroke-spinner-default{stroke:#fff}:host{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.spinner{background-color:transparent;border-radius:50%;height:100%;margin:0 auto;position:relative;--spinner-moving-path-color: #fe5000;height:64px;width:64px}.spinner__paths{animation:rotate 2s linear infinite;height:100%;inset:0;margin:auto;position:absolute;transform-origin:center center;width:100%}.spinner__moving-path{animation:dash 1.1s ease-in-out infinite;stroke-dasharray:1,200;stroke-dashoffset:0;stroke-linecap:square}.spinner--secondary{--spinner-moving-path-color: #ffffff}.spinner--large{height:48px;width:48px}.spinner--medium{height:32px;width:32px}.spinner--small{height:24px;width:24px}.spinner--extra-small{height:16px;width:16px}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:130,200;stroke-dashoffset:-70px}to{stroke-dasharray:130,200;stroke-dashoffset:-175px}}\n"] }]
        }], propDecorators: { size: [{
                type: Input
            }], type: [{
                type: Input
            }] } });

class EquisSpinnerModule {
    static forRoot() {
        return {
            ngModule: EquisSpinnerModule,
        };
    }
}
EquisSpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisSpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisSpinnerModule, declarations: [EquisSpinnerComponent], imports: [CommonModule], exports: [EquisSpinnerComponent] });
EquisSpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisSpinnerModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisSpinnerComponent],
                    imports: [CommonModule],
                    exports: [EquisSpinnerComponent],
                }]
        }] });

/*
 * Public API Surface of z-spinner
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisSpinnerComponent, EquisSpinnerModule, EquisSpinnerSizes, EquisSpinnerTypes };
